import { resolve } from 'path';
import { CootjeService, ICootjeEmployee  } from "../../services/index";
import * as moment from "moment";
import * as _ from "lodash";

class QuotationsCootjeController implements ng.IComponentController {

    /** Injectables */

    private sortType: string;

    private startDate: any;
    private endDate: any;
    private list: ICootjeEmployee[];
    private moment: any;
    currentItem: any;
    repport: any;
    loading: boolean = false;
    hasKM: boolean = false;


    constructor(
        private CootjeService: CootjeService,
        private $stateParams: ng.ui.IStateParamsService,
        private $scope: ng.IScope,
    ) {
        'ngInject';
    }

    public $onInit = () => {

        /** Set return URI */

        // this.TwinfieldService.setTwinfieldRedirectUri();

        // this.proformaInvoicesOnly = this.$stateParams['proformaInvoicesOnly'];

        this.sortType = 'account.name';
        this.moment = require('moment');

        this.startDate = this.moment().startOf('isoweek').toDate();
        this.endDate = this.moment().endOf('isoweek').toDate();


        this.getCootje()
    }

    startDateBeforeRender($dates) {
    }

    endDateBeforeRender($view, $dates) {
        if (this.startDate) {
            var activeDate = moment(this.startDate).subtract(1, $view).add(1, 'minute');

            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    }

    prevWeek() {
        this.startDate = this.moment(this.startDate).add(-7, 'day').toDate();
        this.endDate = this.moment(this.endDate).add(-7, 'day').toDate();
    }
    
    nextWeek() {
        this.startDate = this.moment(this.startDate).add(7, 'day').toDate();
        this.endDate = this.moment(this.endDate).add(7, 'day').toDate();
    }

    getCootje() {
        this.CootjeService.customGet('', {from: this.startDate, till: this.endDate}).then((result: any) => {
            this.list = result;
            if(this.currentItem) {
                this.selectInvoice(this.list.find(i => i.employeeId == this.currentItem.employeeId ));
            }
        });
    }

    selectInvoice(item) {
        this.currentItem= item;
        this.hasKM = false;
        this.currentItem.diensten.forEach(dienst => {
            dienst.declarations.forEach(declaration => {
                if(declaration.registrationType == 2) {
                    this.hasKM = true;
                }
            })
        });

    }

    sendCootje() {
       
        this.loading = true;
        (<any>$('#sendToCootjeModal')).modal('show');

        console.log(this.currentItem)
        this.CootjeService.sendToCootje(this.currentItem.diensten).then((result: any) => {
            this.repport = {'failCount': 0, 'successCount' : 0, 'fail' : [], 'success' : []}

            console.log(result.message);
            this.repport.failCount =  result.message.fail != null ? result.message.fail.length : 0;
            this.repport.successCount = result.message.succes != null ? result.message.succes.length : 0;
            this.repport.fail = result.message.fail;
            this.repport.fail.forEach(fail => {
                fail.shift = this.currentItem.diensten.find(i => i.shiftId == fail.dienstGUID).shift
            });
            this.repport.success = result.message.succes;
            this.repport.success.forEach(success => {
                success.shift = this.currentItem.diensten.find(i => i.shiftId == success.dienstGUID).shift
            });
            this.getCootje();

            this.loading = false;
        });
       
    }
}

export const quotationsCootjeComponent : ng.IComponentOptions = {
    controller : QuotationsCootjeController,
    template :require('./quotations.cootje.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/quotations/quotations.cootje.component.ts